import cn from 'classnames';
import { FC } from 'react';

import { Icon, Input } from '@/Components/UI';

import { calculateChamberIndexColor } from '../../../../../lib/calculateChamberIndexColor';
import { ChamberCardEditProps } from './ChamberCardEditProps';
import S from './styles.module.scss';

export const ChamberCardEdit: FC<ChamberCardEditProps> = ({ chamber, onChangeSpentValue, onChangeInitValue, onChangeProductUdi }) => {
    const chamberIndexColor = calculateChamberIndexColor(chamber.init_value, chamber.spent_value);

    const createUpdateValueFn = (fn: (chamberIndex: number, value?: number) => void) => {
        return (value?: string) => {
            const numberValue = Number(value);

            if (!Number.isNaN(numberValue)) {
                fn(chamber.index, numberValue);
            }
        };
    };

    return (
        <div className={S.Card}>
            <div className={S.Info}>
                <div className={cn(S.Index, S[`Index_${chamberIndexColor}`])}>{chamber.index}</div>
                <Input min={0} value={chamber.product_udi.toString()} onChange={createUpdateValueFn(onChangeProductUdi)} type="number" />
            </div>
            <div className={S.Values}>
                <div className={S.Value}>
                    <Icon name="whiffs-total" size={18} />
                    <Input min={0} value={chamber.init_value.toString()} onChange={createUpdateValueFn(onChangeInitValue)} type="number" />
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-left" size={18} />
                    <Input min={0} disabled value={String(chamber.init_value - chamber.spent_value)} />
                </div>
                <div className={S.Value}>
                    <Icon name="whiffs-spent" size={18} />
                    <Input min={0} value={chamber.spent_value.toString()} onChange={createUpdateValueFn(onChangeSpentValue)} type="number" />
                </div>
            </div>
            {chamber.products.length > 0 && (
                <div className={S.Products}>
                    <p>
                        <b>Products:</b> {chamber.products.map((product) => product.name).join(', ')}
                    </p>
                </div>
            )}
        </div>
    );
};
